import React, { ChangeEvent, useCallback, useEffect, useRef, useState } from 'react';
import { useGetAllSessions } from 'src/hooks/session.hooks';
import { SessionStatus, UISession, UserRole } from 'types';
import { useSearchParams } from 'react-router-dom';
import { Tabs, TabsRef } from 'flowbite-react';
import { sessionMeetingStatuses } from 'shared-utils';
import { debounce } from 'lodash';
import { Loader } from 'ui';
import SessionCards from './SessionCards';
import NewCreatingPositionLoader from '../position/NewCreatingPositionLoader';
const AlumniConnectSessions = () => {
	const tabsRef = useRef<TabsRef>(null);

	const inputRef = useRef<HTMLInputElement>(null);
	const [searchParams, setSearchParams] = useSearchParams();
	const page = Number(searchParams.get('page')) || 1;
	const [userNameEmail, setUserNameEmail] = useState(searchParams.get('userNameEmail') || '');
	const [tab, setTab] = useState<number>(0);
	const [filterStatus, setFilterStatus] = useState<SessionStatus[]>();
	const [filteredSessions, setFilteredSessions] = useState<UISession[]>([]);

	const sessions = useGetAllSessions(
		{
			filterQuery: {
				userName: userNameEmail,
				page,
				status: filterStatus,
				limit: 15,
			},
		},
		data => {
			const allSessions = data.sessions as UISession[];
			setFilteredSessions(allSessions);
		},
	);

	const changeHandler = (event: ChangeEvent<HTMLInputElement | HTMLInputElement>) => {
		setUserNameEmail(event.target.value);
		setSearchParams({ userNameEmail: event.target.value });
	};
	const handleTabChange = (tab: number) => {
		if (!tab) {
			searchParams.set('page', '');
			setSearchParams(searchParams);
			setFilterStatus(undefined);
		} else if (tab === 1) {
			searchParams.set('page', '');
			setSearchParams(searchParams);
			setFilterStatus([SessionStatus.SCHEDULED, SessionStatus.STARTED]);
		} else {
			searchParams.set('page', '');
			setSearchParams(searchParams);
			setFilterStatus(sessionMeetingStatuses);
		}
		setTab(tab);
	};

	useEffect(() => {
		sessions.refetch();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [filterStatus]);

	const debouncedChangeHandler = useCallback(debounce(changeHandler, 1000), [userNameEmail]);

	return (
		<div className="py-4">
			<div className="my-3 w-[450px] pt-5">
				<input
					ref={inputRef}
					className="relative w-full rounded-lg border-gray-300 py-2.5 pl-4 pr-14 text-sm font-light tracking-wide placeholder-gray-400 transition-all duration-300 focus:border-blue-500 focus:ring focus:ring-blue-500/20 disabled:cursor-not-allowed disabled:opacity-40 dark:border-slate-600 dark:bg-slate-800"
					type="text"
					placeholder="Search by Name or Email"
					defaultValue={userNameEmail}
					onChange={e => debouncedChangeHandler(e)}
				></input>
			</div>
			<div>
				{sessions.isLoading ? (
					// <Loader />
					<NewCreatingPositionLoader showAnimation={true} progressBar={false} customClassCss="!w-[30%] mx-auto " />
				) : (
					<Tabs.Group
						aria-label="Tabs with underline"
						ref={tabsRef}
						className="w-full"
						onActiveTabChange={handleTabChange}
					>
						<Tabs.Item
							active={tab === 0}
							data-testid="interviews-mentor-meeting-status-tab-all"
							title={`All ${tab === 0 ? `(${sessions.data?.total})` : ''}`}
						>
							<SessionCards total={sessions.data?.total} data={filteredSessions} sessionDataCategory={'all'} />
						</Tabs.Item>
						<Tabs.Item
							active={tab === 1}
							data-testid="interviews-mentor-meeting-status-tab-scheduled"
							title={`Scheduled ${tab === 1 ? `(${sessions.data?.total})` : ''}`}
						>
							<SessionCards total={sessions.data?.total} data={filteredSessions} sessionDataCategory={'schedule'} />
						</Tabs.Item>
						<Tabs.Item
							active={tab === 2}
							data-testid="interviews-mentor-meeting-status-tab-completed"
							title={`Completed ${tab === 2 ? `(${sessions.data?.total})` : ''}`}
						>
							<SessionCards total={sessions.data?.total} data={filteredSessions} sessionDataCategory={'complete'} />
						</Tabs.Item>
					</Tabs.Group>
				)}
			</div>
		</div>
	);
};

export default AlumniConnectSessions;
